import { AboutResearchInterface } from "@/src/models/IAboutResearch";
import { ActivityReviewInterface, ObjectiveProgress } from "@/src/models/IActivity";
import { BudgetDataInterface, UsedBudgetInterface } from "@/src/models/IBudgetData";
import { OutputInterface, OutputReportInterface, OutputFileListInterface } from "@/src/models/Result";
import { Form, App, Upload, UploadProps, Table, Flex, Input, InputNumber, Button, Card, DatePicker, List, Modal, Select, notification } from "antd";
import TextArea from "antd/es/input/TextArea";
import axios from "axios";
import { Editor } from "ckeditor5";
import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CkEditor from "../ckeditor/ckEditor";
import { formatNumber, monthcolumn } from "../functionLater";
import { UploadOutlined } from "@ant-design/icons";
import LoadingOverlay from 'react-loading-overlay-ts';
import { ProgressReportPreviewInterface } from "@/src/models/IProgress";
import moment from "moment";


export function PorgressReportEdit(){

    const { project_id,progress_id } = useParams();
    const [IsEditable,setIsEditable] = useState(true);
    const [IsSent,setIsSent] = useState(false);

    const [IsStudent,setIsStudent] = useState(false)

    const [form] = Form.useForm();

    const watchedCompensationValues = Form.useWatch('compensation', form);
    const [UsedCompensationsumHis,setUsedCompensationsumHis] = useState(0)
    const UsedCompensationsum = React.useMemo(() => {
        if (!watchedCompensationValues) return UsedCompensationsumHis;
      
        const total = watchedCompensationValues.reduce(
          (sum: number, item: any) => sum + Number(item?.sum || 0),
          0
        );
      
        return total === 0 ? UsedCompensationsumHis : total;
      }, [watchedCompensationValues, UsedCompensationsumHis]);
    
    const watchedOutcomeValues = Form.useWatch('outcome', form);
    const [UsedOutcomesumHis,setUsedOutcomesumHis] = useState(0)
    const UsedOutcomesum = React.useMemo(() => {
        if (!watchedOutcomeValues) return UsedOutcomesumHis;
      
        const total = watchedOutcomeValues.reduce(
          (sum: number, item: any) => sum + Number(item?.sum || 0),
          0
        );
      
        return total === 0 ? UsedOutcomesumHis : total;
      }, [watchedOutcomeValues, UsedOutcomesumHis]);
   
    const watchedItemexpenseValues = Form.useWatch('itemexpense', form);
    const [UsedItemexpensesumHis,setUsedItemexpensesumHis] = useState(0)
    const UsedItemsum = React.useMemo(() => {
        if (!watchedItemexpenseValues) return UsedItemexpensesumHis;
      
        const total = watchedItemexpenseValues.reduce(
          (sum: number, item: any) => sum + Number(item?.sum || 0),
          0
        );
      
        return total === 0 ? UsedItemexpensesumHis : total;
      }, [watchedItemexpenseValues, UsedItemexpensesumHis]);

   
    const [isActive,setisActive]= useState(true);
    const [isHistory,setisHistory]= useState(false);
    const [TMPSubmitMod,setTMPSubmitMod] = useState(false)
    const [SubmitMod,setSubmitMod] = useState(false)

    const navigate = useNavigate();


    const [ActivityInfo,setActivityInfo] = useState<ActivityReviewInterface[]>([]);
    const [ObjectiveData,setObjective] = useState<ObjectiveProgress[]>([]);

    const [submittedRound,setsubmittedRound] = useState(1)

    const [Output,setOutput] = useState<OutputInterface[]>([])
    const [OutputProgress,setOutputProgress] = useState<OutputReportInterface[]>([])
    const [OutputFileList,setOutputFileList] = useState<OutputFileListInterface[]>([])

    const [OutputMod,setOutputMod] = useState(false);
    const [OutputTopic,setOutputTopic]= useState('');


    const [selectedmonth,setselectedmonth] = useState(99)
    const [endmonth,setEndMonth] = useState(99)
    const [selectedyear,setselectedyear] = useState(9999)

    const [DataFirst,setDataFirst] = useState<AboutResearchInterface[]>([]);

    const [compensationsum,setCompensationSum] = useState(0)
    
    const [compensationMonetry,setCompensationMonetrySum] = useState(0)
    const [compensationPrepared,setCompensationPreparedSum] = useState(0)
    const [compensationIndirect,setCompensationIndirectSum] = useState(0)

    const [outcomesum,setOutcomeSum] = useState(0)
    const [outcomeMonetry,setOutcomeMonetrySum] = useState(0)
    const [outcomePrepared,setOutcomePreparedSum] = useState(0)
    const [outcomeIndirect,setOutcomeIndirectSum] = useState(0)

    const [itemsum,setItemnSum] = useState(0)
    const [itemMonetry,setItemMonetrySum] = useState(0)
    const [itemPrepared,setItemPreparedSum] = useState(0)
    const [itemIndirect,setItemIndirectSum] = useState(0)
    const [compensationItems, setCompensationItems] = useState<BudgetDataInterface[]>([]);
    const [compensationUsedBudget,setCompensationUsedBudget] = useState<UsedBudgetInterface[]>([]);
    const [OutcomeItems, setOutcomeItems] = useState<BudgetDataInterface[]>([]);
    const [OutcomeUsedBudget,setOutcomeUsedBudget] = useState<UsedBudgetInterface[]>([]);
    
    const {message} = App.useApp();
    
    const [Keys, setExpandedRowKeys] = useState<number[]>([]);
  
    const [ItemCost, setItemCost] = useState<BudgetDataInterface[]>([]);
    const [itemUsedBudget,setitemUsedBudget] = useState<UsedBudgetInterface[]>([]);

    const [ProgressSummary,setProgressSummary] = useState("")
    const [ProblemsAndObstacle,setProblemsAndObstacle] = useState("")
    const [Suggestion,setSuggestion] = useState("")
    const [FuturePlan,setFuturePlan] = useState("")

    const BudgetTypeCol = [
        {
          id: 1,
          detail: 'หมวดค่าตอบแทน',
          category:'compensation',
          sum:compensationsum,
          Usedsum:UsedCompensationsum,
          MonetrySum:compensationMonetry,
          PreparedSum:compensationPrepared,
          IndirectSum:compensationIndirect
        },
        {
          id: 2,
          detail: 'หมวดค่าใช้จ่าย',
          category:'outcome',
          sum:outcomesum,
          Usedsum:UsedOutcomesum,
          MonetrySum:outcomeMonetry,
          PreparedSum:outcomePrepared,
          IndirectSum:outcomeIndirect
        },
        {
            id: 3,
            detail: 'หมวดค่าวัสดุ และอุปกรณ์',
            category:'itemexpense',
            sum:itemsum,
            Usedsum:UsedItemsum,
            MonetrySum:itemMonetry,
            PreparedSum:itemPrepared,
            IndirectSum:itemIndirect
          },
          {
            id: 4,
            detail: 'รวม',
            category:'',
            sum:Number(itemsum)+Number(outcomesum)+Number(compensationsum),
            Usedsum:UsedCompensationsum + UsedOutcomesum + UsedItemsum,
            MonetrySum:Number(compensationMonetry)+Number(outcomeMonetry)+Number(itemMonetry),
            PreparedSum:Number(compensationPrepared)+Number(outcomePrepared)+Number(itemPrepared),
            IndirectSum:Number(compensationIndirect)+Number(outcomeIndirect)+Number(itemIndirect)
          }
      ];

    const {ROCKEditors,CKEditors,getHTML} = CkEditor();

    const ProgressSummaryRef = useRef<Editor | null>(null);
    const ProblemsAndObstacleRef = useRef<Editor | null>(null);
    const SuggestionRef = useRef<Editor | null>(null);
    const FuturePlanRef = useRef<Editor | null>(null);

    const [FileType,setFileType] = useState<string | null>(null);
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);

    const [SentData,setSentData] = useState<ProgressReportPreviewInterface>();

    const [CurrentReviewer,setCurrentReviewer] = useState('')
    const [CurrentReviewerName,setCurrentReviewerName] = useState('')
    const [LastReviewResult,setLastReviewResult] = useState('')
    const [LastReviewSubmittedDate,setLastReviewSubmittedDate] = useState(moment())
    const [Note,setNote] = useState('')


      const handleExpand = (expanded: boolean, record: any) => {
        setisActive(true)
        if (expanded) {
            console.log(record.id)
            setExpandedRowKeys([record.id]); 
            setisActive(false)

        } else {
            setExpandedRowKeys([]); // Collapse all rows
            setisActive(false)
        }
    };
    const beforeUpload = (file : any) => {
        const encodedFileName = encodeURIComponent(file.name);
        const newFile = new File([file], encodedFileName, { type: file.type });
        const isPDF = file.type === 'application/pdf';
        if (!isPDF) {
          message.error('โปรดอัพโหลดไฟล์ PDF เท่านั้น');
          return Upload.LIST_IGNORE;
        }
        return newFile;
      }

    const props: UploadProps = {
        name: 'file',
        accept: ".pdf",
        action:  `${process.env.REACT_APP_BASE}/UploadOutput/${project_id}`,
        multiple: true,
        headers: {
          authorization: 'authorization-text',
        },
        onChange(info) {
          if (info.file.status !== 'uploading') {
            console.log(info.file, info.fileList);
          }
          if (info.file.status === 'done') {
            message.success(`${info.file.name} อัพสำเร็จ`);
          } else if (info.file.status === 'error') {
            message.error(`${info.file.name} file upload failed.`);
          }
        },
      };
    
    const handleProgressSummaryEditorChange = () =>{
        setProgressSummary(getHTML(ProgressSummaryRef))
    }
    const handleProblemsAndObstacleEditorChange = () =>{
        setProblemsAndObstacle(getHTML(ProblemsAndObstacleRef))
    }
    const handleSuggestionEditorChange = () =>{
        setSuggestion(getHTML(SuggestionRef))
    }
    const handleFuturePlanEditorChange = () =>{
        setFuturePlan(getHTML(FuturePlanRef))
    }

    const getData = async() =>{
        await axios.get(`${process.env.REACT_APP_BASE}/BudgetReqInfo/${project_id}/${sessionStorage.getItem('user')}`).then(response=>{
            setDataFirst(response.data.main)

            if(response.data.main[0].budget_type=='ทุนวิจัยเชิงนวัตกรรมสำหรับนักศึกษา'){
                setIsStudent(true)
            }

            if(response.data.main[0].period){
                const dataperiod = JSON.parse(response.data.main[0].period)
                const datamonth = dataperiod[0].split('-')
                const datamonth2 = dataperiod[1].split('-')
                setselectedmonth(Number(datamonth[1]))
                setEndMonth(Number(datamonth2[1]))
                setselectedyear(Number(datamonth[0]))
            }

            if(response.data.compensation.length!=0||response.data.outcome.length!=0||response.data.itemexpense.length!=0){
                setCompensationItems(response.data.compensation)
                setCompensationUsedBudget(response.data.compensation)
                const totalCompensation = response.data.compensation.reduce((sum: any, item: any) => sum + item.Budget, 0);
                setCompensationSum(totalCompensation)
                const totalMonetryCompensationBudget = response.data.compensation
                    .filter((item:any) => item.BudgetType === "ตัวเงิน(เบิกจ่าย)")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setCompensationMonetrySum(totalMonetryCompensationBudget)
                const totalPreparedCompensationBudget = response.data.compensation
                    .filter((item:any) => item.BudgetType === "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setCompensationPreparedSum(totalPreparedCompensationBudget)
                const totalIndirectCompensationBudget = response.data.compensation
                    .filter((item:any) => item.BudgetType === "ไม่เป็นตัวเงิน(งบอ้อม)")
                    .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setCompensationIndirectSum(totalIndirectCompensationBudget)
            
                const totalOutcome = response.data.outcome.reduce((sum: any, item: any) => sum + item.Budget, 0);
                setOutcomeSum(totalOutcome)
                setOutcomeItems(response.data.outcome)
                setOutcomeUsedBudget(response.data.outcome)
                const totalMonetryOutcomeBudget = response.data.outcome
                .filter((item:any) => item.BudgetType === "ตัวเงิน(เบิกจ่าย)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setOutcomeMonetrySum(totalMonetryOutcomeBudget)
                const totalPreparedOutcomeBudget = response.data.outcome
                .filter((item:any) => item.BudgetType === "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setOutcomePreparedSum(totalPreparedOutcomeBudget)
                const totalIndirectdOutcomeBudget = response.data.outcome
                .filter((item:any) => item.BudgetType === "ไม่เป็นตัวเงิน(งบอ้อม)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setOutcomeIndirectSum(totalIndirectdOutcomeBudget)

                const totalItem = response.data.itemexpense.reduce((sum: any, item: any) => sum + item.Budget, 0);
                setItemnSum(totalItem)
                setItemCost(response.data.itemexpense)
                setitemUsedBudget(response.data.itemexpense)
                const totalMonetryItemBudget = response.data.itemexpense
                .filter((item:any) => item.BudgetType === "ตัวเงิน(เบิกจ่าย)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setItemMonetrySum(totalMonetryItemBudget)
                const totalPreparedItemeBudget = response.data.itemexpense
                .filter((item:any) => item.BudgetType === "ไม่เบิกจ่าย/ให้มหาวิทยาลัยจัดหาให้")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setItemPreparedSum(totalPreparedItemeBudget)
                const itemMonetrySum = response.data.itemexpense
                .filter((item:any) => item.BudgetType === "ไม่เป็นตัวเงิน(งบอ้อม)")
                .reduce((sum:any, item:any) => sum + item.Budget, 0);
                setItemIndirectSum(itemMonetrySum)
                
            }
            if(response.data.main[0].output&&response.data.main[0].outcome&&response.data.main[0].impacts){
                setOutput(JSON.parse(response.data.main[0].output))
                setOutputProgress(JSON.parse(response.data.main[0].output))
              }
              setisActive(false)
        })
    }

    const getReportDetail = async() =>{
        await axios.get(`${process.env.REACT_APP_BASE}/GetProgressData/${progress_id}/${sessionStorage.getItem('user')}`).then(response=>{
            if(response.status==200){
                if(response.data.main[0].ReportStatus=='มีข้อแก้ไข'||response.data.main[0].ReportStatus=='บันทึกชั่วคราว'){
                    setIsEditable(false)
                    setsubmittedRound(response.data.main[0].SentOrder)
                    getReview(response.data.main[0].ProgressReportID)
                    setExpandedRowKeys([1, 2, 3]);

                    if(response.data.main[0].ReportStatus=='บันทึกชั่วคราว'){
                        setIsSent(true)
                    }
                }

                setProgressSummary(response.data.main[0].ProgressionSummary)
                setProblemsAndObstacle(response.data.main[0].ProblemAndObstacle)
                setSuggestion(response.data.main[0].SuggestionAndInformation)
                setFuturePlan(response.data.main[0].ProgressPlan)

                console.log(response.data.activity)

                form.setFields(response.data.activity)

                const activityformatted = response.data.activity.map((item: { ActivityRatio: any; note: any; })=>({
                    ProgressionPercent: item.ActivityRatio,
                    note: item.note,
                }))
                form.setFieldValue('ActivityData', activityformatted);

                if(response.data.main[0]){
                    setSentData(response.data.main[0])
                }
                const compensationformatted = response.data.compensationbudget.map((item: { Spent: any; note: any; })=>({
                    sum:parseFloat(item.Spent),
                    note:item.note
                }))
                form.setFieldValue('compensation', compensationformatted);
                

                const outcomeformatted = response.data.compensationbudget.map((item: { Spent: any; note: any; })=>({
                    sum:parseFloat(item.Spent),
                    note:item.note
                }))
                form.setFieldValue('outcome', outcomeformatted);


                const itemexpenseformatted = response.data.compensationbudget.map((item: { Spent: any; note: any; })=>({
                    sum:parseFloat(item.Spent),
                    note:item.note
                }))
                form.setFieldValue('itemexpense', itemexpenseformatted);
                

                const objformatted = response.data.obj.map((item: { ActivityName: any; SixMonthProgress: any; SixMonthPlan: any; ObjectiveID: any; ProgressReportID: any; }) => ({
                    ActivityName: item.ActivityName,
                    PastProgress: item.SixMonthProgress,
                    FuturePlan: item.SixMonthPlan,
                    ObjectiveID: item.ObjectiveID,
                    ProgressReportID: item.ProgressReportID,
                  }));
                  
                  form.setFieldValue('ActivityInfo', objformatted);

                const outputformatted = response.data.output.map((item: {
                    SentYear: any; Progresspercentage: any; RealOutput: any; Attachment: any; 
                })=>({
                    Progresspercentage:item.Progresspercentage,
                    SentYear: moment(item.SentYear).isValid() ? moment(item.SentYear) : null,
                    RealOutput:item.RealOutput,
                    Attachment:item.Attachment,
                }))
                form.setFieldValue('Output', outputformatted);

                setUsedCompensationsumHis(
                    response.data.compensationbudget.reduce(
                        (sum: number, item: { Spent: any; }) => sum + Number(item.Spent || 0),
                        0
                      )
                )
                setUsedOutcomesumHis(
                    response.data.outcomebudget.reduce(
                        (sum: number, item: { Spent: any; }) => sum + Number(item.Spent || 0),
                        0
                ))
                setUsedItemexpensesumHis(
                    response.data.itemexpensebudget.reduce(
                        (sum: number, item: { Spent: any; }) => sum + Number(item.Spent || 0),
                        0
                ))

                form.setFieldsValue(
                    {
                        compensation:
                            response.data.compensationbudget.map((item: { Spent: any; note: any; })=>({
                                sum:item.Spent,
                                note:item.note,
                            }))
                        ,
                        outcome: response.data.outcomebudget.map((item: { Spent: any; note: any; })=>({
                                sum:item.Spent,
                                note:item.note,
                            })),
                        itemexpense: response.data.itemexpensebudget.map((item: { Spent: any; note: any; })=>({
                                sum:item.Spent,
                                note:item.note,
                            })),
                    }

                )
            }
        })
    
    }

    const getReview = async(progressrep_id:any) => {
        await axios.get(`${process.env.REACT_APP_BASE}/getProgressReportReview/${progressrep_id}`).then(resp=>{
            if(resp.status==200){
                console.log(resp.data)
                setNote(resp.data.note)
                setCurrentReviewer(resp.data.ReviewerPosition)
                setCurrentReviewerName(resp.data.ReviewerName)
                setLastReviewResult(resp.data.ApprovedStatus)
                setLastReviewSubmittedDate(moment(resp.data.SummittedDate))
            }
        })
    }

    const getFilelist = async(Output:any) =>{
        const data = {
            Output : Output
        }
        axios.post(`${process.env.REACT_APP_BASE}/getOutputFileList/${project_id}/${submittedRound}`,data).then((response)=>{
            if(response.status==200){
                setOutputFileList(response.data)
                setOutputTopic(Output)
                setOutputMod(true)
            }
        })
    }

    const viewFile = async(Output:any,FileID:number)=>{
        const data = {
            Output:Output,
        }
        await axios.post(`${process.env.REACT_APP_BASE}/GetOutputFile/${FileID}`,data,
        { responseType: 'blob' }).then(response=>{
            if (response.status === 200) {
                setFileType(response.headers['content-type'])

                const blob = response.data; 
                const blobUrl = URL.createObjectURL(blob);
    
                setPreviewUrl(blobUrl); 
            }
        })

    }

    const DeleteFile = async(Output:any,FileID:number) =>{
        axios.delete(`${process.env.REACT_APP_BASE}/DelOutputFile/${FileID}/${project_id}/${submittedRound}`).then(response=>{
            if(response.status==200){
                notification.success({message:'ลบไฟล์สำเร็จ'})
            }
        })
    }

    async function senddata(){
        const ReportData = form.getFieldsValue();
        
        let TMPActivity = JSON.parse(DataFirst[0].activity)

        let x = TMPActivity
        x.forEach((item: { ActivityRatio: any; }, index: string | number) => {
            item.ActivityRatio = ReportData.ActivityData?.[index]?.ProgressionPercent || '';
        });
        x.forEach((item: { note: any; }, index: string | number) => {
            item.note = ReportData.ActivityData?.[index]?.note || '';
        });

        let y = TMPActivity


        y.forEach((item: { SixMonthProgress: any; }, index: string | number)=>{
            item.SixMonthProgress = ReportData.ActivityInfo?.[index]?.PastProgress|| ''
        })
        y.forEach((item: { SixMonthPlan: any; }, index: string | number)=>{
            item.SixMonthPlan = ReportData.ActivityInfo?.[index]?.FuturePlan|| ''
        })

        setObjective(y)

       let tmpOut = OutputProgress
       tmpOut.forEach((item, index: string | number)=>{
        item.SentYear= ReportData.Output?.[index]?.SentYear;
        item.RealOutput= ReportData.Output?.[index]?.RealOutput;
        item.Progresspercentage= ReportData.Output?.[index]?.Progresspercentage;
        item.Attachment= ReportData.Output?.[index]?.Attachment;
       })
       console.log(tmpOut)

       const FundData = form.getFieldsValue();

       let compensationUsedBudgetFundTmpData = compensationUsedBudget
       compensationUsedBudgetFundTmpData.forEach((item, index)=>{
        item.Spent = parseInt(FundData.compensation?.[index]?.sum)
        item.note = FundData.compensation?.[index]?.note
        || ''
        })
        let OutcomeUsedBudgetFundTmpData = OutcomeUsedBudget
        OutcomeUsedBudgetFundTmpData.forEach((item, index)=>{
        item.Spent = parseInt(FundData.outcome?.[index]?.sum)
        item.note = FundData.outcome?.[index]?.note
        || ''
        })
        let ItemUsedBudgetFundTmpData = itemUsedBudget
        ItemUsedBudgetFundTmpData.forEach((item, index)=>{
        item.Spent = parseInt(FundData.itemexpense?.[index]?.sum)
        item.note = FundData.itemexpense?.[index]?.note
        || ''
        })
        const BackData = {
            round:submittedRound,
            ActivityProgress:x,
            Objective:y,
            ProcessResult:ProgressSummary,
            ProblemAndObstacle:ProblemsAndObstacle,
            SuggestionAndExtraInfo:Suggestion,
            FundHistory:{
                compensation : compensationUsedBudgetFundTmpData,
                outcome : OutcomeUsedBudgetFundTmpData,
                item : ItemUsedBudgetFundTmpData
            },
            ProgressPlan:FuturePlan,
            output:tmpOut,
            sender:sessionStorage.getItem('user')
        }

        console.log(BackData)

        await axios.post(`${process.env.REACT_APP_BASE}/EditProgress/${sessionStorage.getItem('user')}/${progress_id}`,BackData).then(response=>{
            if(response.status==200){
                console.log('test')
                navigate(`/VRIIS/ProgressReportCheck/${project_id}`)
            }
        })
     }

     async function sendTMPData(){
        const ReportData = form.getFieldsValue();
        
        let TMPActivity = JSON.parse(DataFirst[0].activity)

        let x = TMPActivity
        x.forEach((item: { ActivityRatio: any; }, index: string | number) => {
            item.ActivityRatio = ReportData.ActivityData?.[index]?.ProgressionPercent || '';
        });
        x.forEach((item: { note: any; }, index: string | number) => {
            item.note = ReportData.ActivityData?.[index]?.note || '';
        });

        let y = TMPActivity


        y.forEach((item: { SixMonthProgress: any; }, index: string | number)=>{
            item.SixMonthProgress = ReportData.ActivityInfo?.[index]?.PastProgress|| ''
        })
        y.forEach((item: { SixMonthPlan: any; }, index: string | number)=>{
            item.SixMonthPlan = ReportData.ActivityInfo?.[index]?.FuturePlan|| ''
        })

        setObjective(y)

       let tmpOut = OutputProgress
       tmpOut.forEach((item, index: string | number)=>{
        item.SentYear= ReportData.Output?.[index]?.SentYear;
        item.RealOutput= ReportData.Output?.[index]?.RealOutput;
        item.Progresspercentage= ReportData.Output?.[index]?.Progresspercentage;
        item.Attachment= ReportData.Output?.[index]?.Attachment;
       })
       console.log(tmpOut)

       const FundData = form.getFieldsValue();

       let compensationUsedBudgetFundTmpData = compensationUsedBudget
       compensationUsedBudgetFundTmpData.forEach((item, index)=>{
        item.Spent = parseInt(FundData.compensation?.[index]?.sum)
        item.note = FundData.compensation?.[index]?.note
        || ''
        })
        let OutcomeUsedBudgetFundTmpData = OutcomeUsedBudget
        OutcomeUsedBudgetFundTmpData.forEach((item, index)=>{
        item.Spent = parseInt(FundData.outcome?.[index]?.sum)
        item.note = FundData.outcome?.[index]?.note
        || ''
        })
        let ItemUsedBudgetFundTmpData = itemUsedBudget
        ItemUsedBudgetFundTmpData.forEach((item, index)=>{
        item.Spent = parseInt(FundData.itemexpense?.[index]?.sum)
        item.note = FundData.itemexpense?.[index]?.note
        || ''
        })
        const BackData = {
            round:submittedRound,
            ActivityProgress:x,
            Objective:y,
            ProcessResult:ProgressSummary,
            ProblemAndObstacle:ProblemsAndObstacle,
            SuggestionAndExtraInfo:Suggestion,
            FundHistory:{
                compensation : compensationUsedBudgetFundTmpData,
                outcome : OutcomeUsedBudgetFundTmpData,
                item : ItemUsedBudgetFundTmpData
            },
            ProgressPlan:FuturePlan,
            output:tmpOut,
            sender:sessionStorage.getItem('user')
        }

        console.log(BackData)

        await axios.post(`${process.env.REACT_APP_BASE}/TemperaryEdit/${sessionStorage.getItem('user')}/${progress_id}`,BackData).then(response=>{
            if(response.status==200){
                window.location.reload();
            }
        })
     }

    const expandedRowRender = (tempdata: any) => {
        let dataSource: any[] = [];

      const category = tempdata.category

      if (tempdata.category === 'compensation') {
        dataSource = compensationUsedBudget;
      } else if (tempdata.category === 'outcome') {
        dataSource = OutcomeUsedBudget;
      } else if (tempdata.category === 'itemexpense') {
        dataSource = itemUsedBudget;
      }
    
      return <>
        <Table
            columns={[
                {
                    title: '',
                    width: 37,
                    dataIndex: 'id',
                    key: 'id',
                    render: (_, record) => (
                    <Flex justify="center">
                        <p> </p>
                    </Flex>
                    ),
                },
                {
                    title:'',
                    dataIndex: 'BudgetDetail',
                    key: 'BudgetDetail',
                    width: 450,
                    render: (_, record,index) => (
                        <>
                            <p>{record.BudgetDetail} </p>
                            {typeof dataSource[index]?.note === 'string' && (
                                <p style={{ color: 'gray' }}>{dataSource[index].note}</p>
                            )}
                        </>
                        ),
                },
                {
                    title:'',
                    dataIndex: 'Budget',
                    key: 'Budget',
                    width: 250,
                    render: (_, record) => (
                    <Flex justify="center">{formatNumber(record.Budget)}</Flex>
                    ),},
                {
                    title:'',
                    dataIndex: 'BudgetDetail',
                    key: 'BudgetDetail',
                    width: 250,
                    render: (_, record,index) => (
                        <>
                            <Form.Item name={[category , index,'sum']}>
                                <Input
                                disabled={IsEditable}
                                    type="number"
                                        />
                            </Form.Item>
                        </>
                    ),
                },
                {title:'หมายเหตุ',
                    render: (_, record,index) => (
                        <>
                            <Form.Item 
                            name={[category , index,'note']}
                            >
                                <Input 
                                disabled={IsEditable}
                                onChange={(value)=>
                                    {
                                        let tmpdata = dataSource || []
                                        tmpdata[index].note = value
                                        if (record.category === 'compensation') {
                                            setCompensationUsedBudget(tmpdata);
                                        } else if (record.category === 'outcome') {
                                            setOutcomeUsedBudget(tmpdata);
                                        } else if (record.category === 'itemexpense') {
                                            setitemUsedBudget(tmpdata);
                                        }
                                    }
                                }/>
                            </Form.Item>
                        </>
                    ),}
            ]}
            showHeader={false} 
            pagination={false}
            dataSource={dataSource}/>
      </>
    }

    useEffect(() =>{
    getData();
    getReportDetail();
    },[])


    return(<>
        <LoadingOverlay
                active={isActive}
                spinner
                text='กำลังโหลดข้อมูล'
            >
                <Form
                    form={form}
                    autoComplete="off"
                    layout='vertical'
                  >
                <h1 className="text-3xl font-semibold leading-relaxed">รายงานความก้าวหน้าโครงงานวิจัยที่ถูกยื่นไปในครั้งที่ {progress_id}</h1>
                <br/>
                <hr/>
                <br/>
                {(!IsEditable&&!IsSent)&&<Card>
                    <p style={{fontWeight:'bold'}}>ผลการอนุมัติ</p>
                    <p>ผู้ลงผลอนุมัติ : {CurrentReviewer}</p>
                    <p>ผล : {LastReviewResult}</p>
                    <p>บันทึกข้อความจากเจ้าหน้าที่ : {Note}</p>
                </Card>}
                {
                    isHistory&&
                    <>
                         <h2 className="text-2xl font-bold leading-relaxed"  style={{display: "flex"}} >ประวัติการส่งผลรายงานความก้าวหน้า</h2>
                            <Card style={{marginLeft:'5vw'}}>
                                <p className="font-semibold leading-relaxed" style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>ประวัติการยื่นรายงานครั้งที่&nbsp;&nbsp;<Select style={{width:'10vw'}}/></p>
                                <p></p>
                            </Card>
                            <br/>
                    </>
                }
               
                    <p className="font-bold leading-relaxed" >รายงานผลการดำเนินการวิจัย และการวิเคราะห์ผลการวิจัย</p>
                        <Table
                            columns={[
                                {
                                    title:'แผนการดำเนินงาน',
                                    dataIndex:'ActivityName',
                                    fixed: 'left',  
                                    width: 200,  
                                    className: 'fixed-column'
                                },
                                {
                                  title:'ระยะเวลาที่ทำกิจกรรม',
                                 children:monthcolumn(selectedmonth,endmonth,DataFirst?.[0]?.period? JSON.parse(DataFirst?.[0]?.period): [])
                                },
                               {
                                    title:'ความสำเร็จต่อโครงการ',
                                    dataIndex:'ActivityRatio',
                                    fixed: 'right',  
                                    width: 200, 
                                    className: 'fixed-column',
                                    render: (_, record,index) => (
                                        <>
                                            <Form.Item name={['ActivityData', index,'ProgressionPercent']}>
                                                <InputNumber disabled={IsEditable} defaultValue={0} max={100} suffix='%'/>
                                            </Form.Item>
                                        </>
                                    )
                                },{
                                    title:'หมายเหตุ',
                                    fixed: 'right',  
                                    width: 200, 
                                    className: 'fixed-column',
                                    render: (_, record,index) => (
                                        <>
                                            <Form.Item name={['ActivityData', index,'note']}>
                                                <TextArea disabled={IsEditable}  autoSize={{ minRows: 3, maxRows: 5 }}/>
                                            </Form.Item>
                                        </>
                                    )
                                },
                            ]}
                            dataSource={DataFirst?.[0]?.activity ? JSON.parse(DataFirst[0].activity) : []}
                            scroll={{ x: 'max-content' }}
                            pagination={false}
                        />
                    <p className="font-bold leading-relaxed" >รายละเอียดของขั้นตอนการดำเนินงานจริงตามแผนงาน (ช่วงรายงานผล) </p>
                        <Table
                            columns={[
                                {
                                    title:'วัตถุประสงค์', 
                                    dataIndex:'ActivityName',
                                    width:'20vw'
                                },
                                {
                                    title:'สิ่งที่ดำเนินการ',
                                    render: (_, record,index) => (
                                        <>
                                            <Form.Item name={['ActivityInfo', index,'PastProgress']}>
                                                <TextArea disabled={IsEditable}  autoSize={{ minRows: 3, maxRows: 5 }}/>
                                            </Form.Item>
                                        </>
                                    )
                                },
                                {
                                    title:'สิ่งที่จะดำเนินการ',
                                    render: (_, record,index) => (
                                        <>
                                            <Form.Item name={['ActivityInfo', index,'FuturePlan']}>
                                                <TextArea disabled={IsEditable}  autoSize={{ minRows: 3, maxRows: 5 }}/>
                                            </Form.Item>
                                        </>
                                    )
                                }
                                
                            ]}
                            pagination={false}
                            dataSource={DataFirst?.[0]?.activity ? JSON.parse(DataFirst[0].activity) : []}
                            />
                    <p className="font-semibold">สรุปผลการดำเนินงาน</p>
                    {!IsEditable&&<CKEditors
                        myRef={ProgressSummaryRef}
                        htmlBox={ProgressSummary}
                        onBlur={handleProgressSummaryEditorChange}
                        toolstate={true}
                        />||<ROCKEditors
                        myRef={ProgressSummaryRef}
                        htmlBox={ProgressSummary}
                        toolstate={false}
                        />}
                    <Form.Item label={<p className="font-semibold">ปัญหาและอุปสรรค</p>}>
                    {!IsEditable&&
                        <CKEditors
                            myRef={ProblemsAndObstacleRef}
                            htmlBox={ProblemsAndObstacle}
                            onBlur={handleProblemsAndObstacleEditorChange}
                            toolstate={true}/>||
                        <ROCKEditors
                            myRef={ProblemsAndObstacleRef}
                            htmlBox={ProblemsAndObstacle}
                            toolstate={false}
                            />}
                        
                    </Form.Item>
                    <Form.Item label={<p className="font-semibold">คำแนะนำและข้อมูลเพิ่มเติมอื่นๆ (ถ้ามี) </p>}>
                        {!IsEditable&&
                            <CKEditors
                                myRef={SuggestionRef}
                                htmlBox={Suggestion}
                                onBlur={handleProblemsAndObstacleEditorChange}
                                toolstate={true}/>||
                            <ROCKEditors
                                myRef={SuggestionRef}
                                htmlBox={Suggestion}
                                toolstate={false}
                                />}
                    </Form.Item>
                    <p className="font-semibold">รายจ่ายที่เกิดขึ้นจริง</p>
                        <Table
                            rowKey="id"
                            columns={[
                                {
                                    title:'หมวดรายการงบประมาณ',
                                    dataIndex:'detail',
                                    width: 450,
                                },
                                {
                                    title:'งบประมาณ (บาท)',
                                    width: 500,
                                    children:[
                                        {
                                            title:'งบประมาณที่ได้รับ',
                                            width: 250,
                                            render: (_, record) => (
                                              <Flex justify="center">{formatNumber(record.MonetrySum+record.PreparedSum+record.IndirectSum)}</Flex>
                                            ),},
                                        {
                                            title:'จำนวนเงินที่ใช้ไป',
                                            width: 250,
                                            render: (_, record) => (
                                              <>
                                                <Flex justify="center">
                                                    <p>{formatNumber(record.Usedsum)}</p>
                                                </Flex>
                                              </>
                                        )},
                                    ]
                                },
                                {
                                    title:'หมายเหตุ',
                                    render: (_, record) => (
                                        <>
                                          <Flex justify="center">
                                            <p>-</p>
                                          </Flex>
                                        </>
                                  )
                                },
                            ]}
                            expandable={{
                                expandedRowRender,
                                expandedRowKeys: Keys,
                                onExpand: handleExpand,
                                rowExpandable: (record) => {
                                    if (record.category === 'compensation') return compensationItems.length > 0;
                                    if (record.category === 'outcome') return OutcomeItems.length > 0;
                                    if (record.category === 'itemexpense') return ItemCost.length > 0;
                                    return false;
                                  },
                            }}
                            scroll={{ x: 'max-content' }}
                            dataSource={BudgetTypeCol}
                            pagination={false}
                            />
                    <br/>
                    <p className="font-semibold">ผลผลิตที่คาดว่าจะได้รับ</p>
                    <Table
                        columns={[
                            {
                                title:'ผลผลิต',
                                dataIndex:'Output_name',
                                fixed: 'left',  
                                width: 200,  
                                className: 'fixed-column'
                            },{
                                title: 'จำนวนนำส่ง/หน่วยนับ',
                                dataIndex:'Output_amount',
                                key: 'Output_amount',
                                render: (_, record) => (
                                    <>
                                        <p>{record.Output_amount} {record.Output_unit}</p>
                                    </>
                                  ),
                            },{
                                title:'รายละเอียดผลผลิต',
                                dataIndex:'Output_description'
                            },{
                                title:'ปีที่นำส่งผลผลิต',
                                render: (_, record,index) => (
                                    <>
                                        <Form.Item name={['Output',index,'SentYear']}>
                                            <DatePicker 
                                            disabled={IsEditable}
                                            picker="year" placeholder=''/>
                                        </Form.Item>
                                    </>
                                  ),
                            },{
                                title:'เปอร์เซ็นความก้าวหน้าการดำเนินงาน',
                                render: (_, record,index) => (
                                    <>
                                        <Flex justify='center'>
                                        <Form.Item name={['Output',index,'Progresspercentage']}>
                                            <InputNumber
                                            disabled={IsEditable}
                                            suffix='%'/>
                                        </Form.Item></Flex>
                                    </>
                                  ),
                            },{
                                title:'ผลผลิตที่เกิดขึ้นจริง',
                                render: (_, record,index) => (
                                    <>
                                        <Form.Item name={['Output',index,'RealOutput']}>
                                            <TextArea 
                                            disabled={IsEditable}
                                             autoSize={{ maxRows: 5 }}/>
                                        </Form.Item>
                                    </>
                                  ),
                            },{
                                title:'หลักฐาน/เอกสารประกอบ',
                                render: (_, record,index) => (
                                    <>
                                        <Form.Item name={['Output',index,'Attachment']}>
                                            <TextArea 
                                            disabled={IsEditable}
                                             autoSize={{ maxRows: 5 }}/>
                                        </Form.Item>
                                    </>
                                  ),
                              
                            },{
                                title:'ไฟล์แนบ',
                                width: 200,
                                render: (_, record) => (
                                    <>
                                        <Flex justify='center'>
                                            <Upload {...props}
                                                data={(file)=>({
                                                    Output_name: record.Output_name,
                                                    filename: file.name,
                                                    ProgressReportID:submittedRound
                                                })}
                                                beforeUpload={beforeUpload}
                                            >
                                                <Button
                                                    disabled={IsEditable}
                                                    icon={<UploadOutlined />}>อัพโหลดไฟล์ PDF</Button>
                                            </Upload>
                                        </Flex>
                                        <br/>
                                        <Flex justify='center'>
                                            <Button onClick={()=>{
                                               getFilelist(record.Output_name)
                                            }}>ดูข้อมูลไฟล์ที่อัพโหลด</Button>
                                        </Flex>
                                    </>
                                  ), 
                            }
                        ]}
                        pagination={false}
                        scroll={{ x: 'max-content' }}
                        dataSource={Output}/>
                    <br/>
                    <Modal
                    title={`รายชื่อไฟล์ที่เพิ่มเข้ามาในระบบ : ${OutputTopic}`}
                    open={OutputMod}
                    onCancel={()=>{
                        setOutputMod(false)
                        setPreviewUrl(null)
                    }}
                    footer={<></>}>
                    <hr/>
                    <List
                    bordered
                    renderItem={(item, index) =>(
                        <><List.Item
                            actions={[
                                <> 
                                    <a onClick={()=>viewFile(item.Output,item.FileID)}
                                    style={{ color: 'blue', textDecoration: 'none', cursor: 'pointer' }}
                                    onMouseEnter={(e) => (e.currentTarget.style.color = '#1890ff')}
                                    onMouseLeave={(e) => (e.currentTarget.style.color = 'blue')}>
                                        ดูไฟล์</a>&nbsp;| &nbsp;
                                    {!IsEditable&&
                                        <a onClick={()=>DeleteFile(item.Output,item.FileID)}
                                            style={{ color: 'blue', textDecoration: 'none', cursor: 'pointer' }}
                                            onMouseEnter={(e) => (e.currentTarget.style.color = '#1890ff')}
                                            onMouseLeave={(e) => (e.currentTarget.style.color = 'blue')}>
                                        ลบไฟล์</a>}
                                </>
                             ]}>
                            <List.Item.Meta
                                title={<p>{item.Filename}</p>}
                            />
                        </List.Item>
                            <br/>
                        
                        </>
                    )}
                    dataSource={OutputFileList}/>
                    {previewUrl&&<>
                        <iframe src={previewUrl} 
                         width="100%"
                         height="600px"
                         title="PDF Viewer"/>
                    </>}
                    </Modal>
                    {(SentData?.ReportStatus=='มีข้อแก้ไข'||SentData?.ReportStatus=='บันทึกชั่วคราว')&&
                    <>
                        <Flex justify='center'>
                            <Button onClick={()=>setTMPSubmitMod(true)}>บันทึกชั่วคราว</Button>
                        </Flex>
                        <br/>
                        <Flex justify='center'>
                            <Button onClick={()=>setSubmitMod(true)}>ยื่นรายงานความก้าวหน้า</Button>
                        </Flex>
                    </>}
                </Form>

                {SentData?.ReportStatus=='ผ่าน'&&
                    <Flex justify='center'>
                        <Button type='primary' href={`${process.env.REACT_APP_BASE}/exportProgressRep/${progress_id}/${sessionStorage.user}`}>ดาวน์โหลดข้อมูลโครงการ</Button>
                    </Flex>
                }

                <Modal
                title='ยืนยันการบันทึกชั่วคราว'
                footer={<></>}
                open={TMPSubmitMod}
                onCancel={()=>setTMPSubmitMod(false)}>
                    <p>คุณต้องการบันทึกข้อมูลหรือไม่</p>
                    <br/>
                    <p>การบันทึกนี้จะเป็นการบันทึกข้อมูลลงระบบเท่านั้น แต่จะไม่ยื่นข้อมูลแก่เจ้าหน้าที่</p>
                    <Flex justify='flex-end'><Button type='primary' onClick={()=>setTMPSubmitMod(false)} danger>ยกเลิก</Button>&nbsp;<Button  type='primary' onClick={()=>sendTMPData()}>ตกลง</Button></Flex>
                </Modal>

                <Modal
                title='ยืนยันการยื่นรายงาน'
                footer={<></>}
                open={SubmitMod}
                onCancel={()=>setSubmitMod(false)}>
                    <p>คุณต้องการยืนยันผลการแก้ไขรายงานหรือไม่</p>
                    <Flex justify='flex-end'><Button type='primary' onClick={()=>setSubmitMod(false)} danger>ยกเลิก</Button>&nbsp;<Button  type='primary' onClick={()=>senddata()}>ตกลง</Button></Flex>
                </Modal>
            </LoadingOverlay>

    </>)
}